import { parsePhoneNumber } from "libphonenumber-js/mobile";

import { GroupType, UnitType } from "@/types";

/**
 * Sets the V2 frontend feature flag in local storage.
 *
 * @param value - A string representing whether the V2 frontend is enabled ("true") or disabled ("false").
 */
export const setV2FrontendEnabled = (value: string) =>
  localStorage.setItem("v2", value);

/**
 * Checks if the V2 frontend feature flag is enabled in local storage.
 *
 * @returns A boolean indicating whether the V2 frontend is enabled.
 */
export const isV2FrontendEnabled = () => localStorage.getItem("v2") !== "false";

// We mask all the numbers in a phone number with * except for the last two digits
// Ex: 1 (602) 555-5555 returns (602) ***-**55
export const maskPhoneNumber = (phoneNumber: string | null): string | null => {
  if (!phoneNumber || phoneNumber === "") {
    return null;
  }

  const parsedPhone = parsePhoneNumber(phoneNumber, "US").formatNational();
  const [areaCode, number] = parsedPhone.split(" ");
  // All numbers except the last two digits
  const regex = /\d(?!\d{0,1}$)/gm;
  const maskedPhoneNumber = number.replace(regex, "*");

  return `${areaCode} ${maskedPhoneNumber}`;
};

export const formatAddress = (unit: Partial<UnitType> | Partial<GroupType>) => {
  return [
    [unit.streetAddress1, unit.streetAddress2, unit.city]
      .filter(Boolean)
      .join(", "),
    unit.zip,
  ]
    .filter(Boolean)
    .join(" ");
};
